
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verify-proofs",
      function () {
        return require("private-next-pages/verify-proofs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verify-proofs"])
      });
    }
  